/* src/app/global/components/global-page-not-found/global-page-not-found.component.scss */
/*# sourceMappingURL=global-page-not-found.component.css.map */
